/**
 * @description: Google Recaptcha Controller.
 */
function googleRecaptchaController() {

}

export default googleRecaptchaController;



// WEBPACK FOOTER //
// ./src/components/googlerecaptcha/google-recaptcha.controller.js